import { isBrandableKey } from "./brandable-keys";

/**
 * Rebrands product copy for an organisation with its own brand.
 *
 * "INFINIT" means two different things in this app, and only one may be renamed:
 *
 *  - the **tool** the dealer is using ("INFINIT AI", "Welcome to INFINIT") —
 *    this becomes the organisation's brand;
 *  - the **counterparty**: the entity holding the bank account, providing the
 *    stock financing, issuing invoices, named in personal guarantees and owning
 *    the copyright — this must never be renamed.
 *
 * The two sit side by side in the same modules, so the decision is made per
 * translation key via an explicit opt-in list, never by inspecting the copy.
 * A content rule could only ever be written in one language, and the copy is
 * translated into five — the pilot organisation is French, where an
 * English-worded rule protects almost nothing.
 */

/** Whole-word "INFINIT" only, so "INFINITY" is never touched. Case-insensitive
 * so title-case variants ("Infinit") rebrand consistently. */
const INFINIT_TOKEN = /\bINFINIT\b/gi;

/**
 * Applied to the raw translation *before* placeholder interpolation, so a value
 * supplied at the call site (a company or supplier name) is never rewritten.
 */
export function applyBrandToTranslation(
	key: string | undefined,
	text: string,
	brandName: string | null | undefined
): string {
	if (!brandName || !text) return text;
	if (!isBrandableKey(key)) return text;
	return text.replace(INFINIT_TOKEN, brandName);
}
